import React from 'react';
import { Helmet } from 'react-helmet';

const Schema = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Solar Care International Pvt Ltd",
    "url": "https://www.solarcareinternational.lk/",
    "logo": "https://www.solarcareinternational.lk/Images/sci-1024x1024.png",
    "founder": {
      "@type": "Person",
      "name": "Dasitha Kodithuwakku",
      "jobTitle": "Founder & Managing Director",
      "image": "https://www.solarcareinternational.lk/Images/dasitha_image_2.jpeg"
    },
    "description": "Get the best solar system maintenance services in Sri Lanka from Solar Care International, the best solar power system maintenance service provider in Sri Lanka. Solar Care International is Sri Lanka’s #1 provider of preventive maintenance, solar installations, and bird proofing solutions for solar panels. Trusted in Sri Lanka & Maldives.",
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "+94-77-712-9021",
        "contactType": "customer support",
        "areaServed": ["LK","MV"],
        "availableLanguage": ["English","Sinhala","Tamil"]
      },
      {
        "@type": "ContactPoint",
        "telephone": "+94-11-419-9225",
        "contactType": "sales",
        "areaServed": ["LK","MV"],
        "availableLanguage": ["English","Sinhala","Tamil"]
      }
    ],
    "sameAs": [
      "https://web.facebook.com/profile.php?id=100091148180919",
      "https://www.instagram.com/solar_care_international/",
      "https://www.youtube.com/@SolarCareInternational",
      "https://www.tiktok.com/@solarcareinternational",
      "https://wa.me/94777129021"
    ],
    "location": [
      {
        "@type": "Place",
        "name": "Sri Jayawardenepura Kotte Office",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Sri Rahula Maha Vidyalaya, No.11,12",
          "addressLocality": "Sri Jayawardenepura Kotte",
          "postalCode": "10100",
          "addressCountry": "LK"
        }
      },
      {
        "@type": "Place",
        "name": "Nugegoda Office",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "44/1A, Chapel Lane",
          "addressLocality": "Nugegoda",
          "postalCode": "10250",
          "addressCountry": "LK"
        }
      }
    ]
  };

  const keywords = `
Solar Care International, Preventive Maintenance and Corrective Maintenance, peak performance, Dasitha Kodithuwakku, solar preventive maintenance Sri Lanka, Solar Maintenance, solar panel cleaning, solar panel maintenance, PV system care, solar bird proofing, solar rodent proofing, PV protection coatings, anti-static solar coating, anti-reflective coating protection, solar panel warranty, solar panel inspection, solar energy solutions, renewable energy Sri Lanka, solar system repair, solar consultation services, solar PV installation, Chemitek solar products, solar system health report, fire safety audit, SLSEA compliance, sustainable energy solutions, solar power optimization, maximize solar ROI, solar system performance, solar preventive coating, solar maintenance company Sri Lanka, solar experts Sri Lanka, Maldives solar services, long-term solar savings, solar investment protection, solar system longevity, solar maintenance checklist, solar maintenance program, PV system cleaning, commercial solar maintenance, residential solar maintenance, reliable solar company, top solar maintenance provider, energy efficiency solar, Solar Care International logo, Solar Care Sri Lanka, free solar quote, professional solar services, total solar care, solar panel preventative care, Sri Lanka solar leader, warranty handling services, inverter repair, DC AC component servicing, certified solar repairs, solar inspection services, rooftop solar solutions, commercial solar installations, domestic solar installations, sustainable PV systems, certified SEA engineers, drone solar inspection, thermal imaging for solar panels, electrical safety audit, panel degradation assessment, pre-installation review report, load and yield analysis, system design review, component assessment, installer checklist, technical documentation, post-installation verification, 
`;
  const companyDetails = {
  name: "Solar Care International (Pvt) Ltd",
  founder: "Dasitha Kodithuwakku",
  ceoTitle: "Founder & Managing Director",
  expertise: "Solar PV Sales Coach & Preventive Maintenance Expert",
  description: `
    Get the best solar system maintenance services in Sri Lanka from Solar Care International, the best solar power system maintenance service provider in Sri Lanka.
    Solar Care International is Sri Lanka’s #1 Solar Preventive Maintenance and Aftercare Solutions Provider. 
    As the Exclusive Authorized Distributor of ChemiTek SA (Portugal) for Sri Lanka and the Maldives, we 
    safeguard solar investments through expert consultation, preventive maintenance, and advanced protective coatings. 
    Over 4,500 technicians have been trained, and we have safeguarded more than 44,000 kW of rooftop solar capacity.
  `,
  vision: `
    To be the driving force in Sri Lanka and the Maldives for a sustainable, renewable energy future where every 
    solar system performs at its best.
  `,
  mission: `
    To safeguard and maximize the performance of every solar investment by delivering world-class preventive 
    maintenance, protective coatings, and aftercare solutions.
  `,
  coreValues: [
    "Sustainability - Eco-friendly practices that protect our planet for future generations.",
    "Innovation - Cutting-edge technologies and smarter solutions for better performance.",
    "Trust & Integrity - Building long-term relationships through honesty and transparency.",
    "Excellence in Service - International-standard preventive maintenance and customer care.",
    "Customer Empowerment - Guiding and supporting solar owners to get the best from their investment."
  ],
  services: [
    "Preventive Maintenance – ensuring maximum output and system reliability",
    "System Health Reports – detailed diagnostics with recommendations for long-term sustainability",
    "SCI Installation Method – unique 41-step process ensuring world-class quality and safety",
    "Solar Panel Cleaning & Advanced Protective Coatings – ChemiTek anti-static and anti-adherent solutions",
    "Warranty & Claims Handling – complete manufacturer liaison and technical support",
    "Bird-Proofing Solutions – protecting solar assets against contamination and damage",
    "Semi-Automated & Fully Automated Cleaning Systems – robotic and mechanized solutions for large-scale arrays"
  ],
  awards: [
    {
      title: "Best Solar Preventive Maintenance Provider in Sri Lanka 2025",
      organization: "Global Business Excellence Awards"
    },
    {
      title: "Most Innovative Solar Company of the Year 2025",
      organization: "Global Business Excellence Awards - Elite Series II"
    },
    {
      title: "Best Solar Preventive Maintenance Provider in Sri Lanka 2025",
      organization: "Iconic Awards"
    }
  ],
  globalRecognition: `
    Recognized as the Best Solar Preventive Maintenance Provider in Sri Lanka by the Global Business Excellence Awards 2025.
    Certificate Reg No: SLSEASBS00808PV002747322023ABT2P1
  `,
  contact: {
    phone: ["077 712 9021", "011 419 9225"],
    email: "solarcareinternational@gmail.com",
    addresses: [
      "Sri Rahula Maha Vidyalaya, No.11,12, Sri Jayawardenepura Kotte 10100",
      "44/1A, Chapel Lane, Nugegoda"
    ],
    hours: "07:00 AM - 19:00 PM"
  },
  tagline: "Protecting Your Solar Investment, Today and for the Future."
};

  return (
    <Helmet>
      <meta name="description" content="Solar Care International is the leading solar company in Sri Lanka, specializing in solar preventive maintenance, panel cleaning, and bird proofing solutions. Trusted across Sri Lanka and the Maldives." />
      <meta name="keywords" content={keywords} />
      <meta name="details" content={JSON.stringify(companyDetails)} />
      <meta name="author" content="Solar Care International Pvt Ltd" />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default Schema;